import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsCrud.vue?vue&type=template&id=74b14e4c"
import script from "./TraxTrainingCompetencyDomainsCrud.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports